<template>
  <div>
    <div class="password-field">
      <input
        :id="inputId"
        class="pop-auth__field"
        :class="{ 'is-invalid': invalid }"
        :type="show ? 'text' : 'password'"
        :placeholder="placeholder"
        :value="value"
        :autocomplete="autocomplete"
        :disabled="disabled"
        :data-test="dataTest"
        @input="$emit('input', $event.target.value)"
        @keyup.enter="$emit('enter')"
      />
      <button type="button" class="pop-auth__link password-field__toggle" @click="show = !show">
        {{ show ? 'Hide' : 'Show' }}
      </button>
    </div>
    <div v-if="error" class="pop-auth__err" :data-test="errorDataTest">{{ error }}</div>
    <password-meter v-else-if="meter" :password="value" />
  </div>
</template>

<script>
import PasswordMeter from './PasswordMeter.vue'

export default {
  name: 'PasswordField',
  components: { PasswordMeter },
  props: {
    value: { type: String, default: '' },
    placeholder: { type: String, default: 'Your password' },
    error: { type: String, default: '' },
    meter: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    autocomplete: { type: String, default: 'current-password' },
    inputId: { type: String, default: undefined },
    dataTest: { type: String, default: undefined },
    errorDataTest: { type: String, default: undefined },
  },
  data() {
    return { show: false }
  },
  computed: {
    invalid() {
      return Boolean(this.error)
    },
  },
}
</script>

<style scoped>
.password-field { position: relative; }
.password-field input { padding-right: 64px; }
.password-field__toggle { position: absolute; right: 16px; top: 50%; transform: translateY(-50%); font-size: 13px; }
</style>
